import { useCallback, useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import _debounce from 'lodash/debounce';
import _ from 'lodash';
import FieldNames from '../../../defaults/FieldNames.json';
import { emitCustomEvent } from 'react-custom-events';

export default function BasicNumberField({
    detail,
    onFieldChange,
    value,
    setValue,
    field,
    label,
    styleOverride,
    variant,
    placeholder,
    useFullWidth,
    helperText,
    isError = false,
    useMultiline = false,
    isDisabled = false,
    inputProps = null,
    type = 'number',
    min = 1,
    max = 300,
    triggerEvent = null,
}) {
    const [localValue, setLocalValue] = useState('');

    const handleTextChange = (event, targetValue, prevValue) => {
        if (prevValue !== targetValue) {
            setValue(targetValue);
            if (triggerEvent) {
                emitCustomEvent(triggerEvent, { field: field, value: targetValue });
            }
        }
    };

    const debounceTextFn = useCallback(_debounce(handleTextChange, 300), []);

    useEffect(() => {
        if (value !== localValue) {
            if (value) {
                setLocalValue(_.clone(value));
            } else if (!value) {
                setLocalValue('');
            }
        }
    }, [value]);

    return (
        <TextField
            label={label}
            key={field}
            style={styleOverride ? styleOverride : { minWidth: 240, marginTop: 10 }}
            value={localValue}
            onChange={(event) => {
                let targetValue = event.target.value;
                if (field === FieldNames.featureFields.vegDeparturePercentageManual) {
                    if (!event.target.value) {
                        targetValue = '';
                    } else if (event.target.value && parseInt(event.target.value) < 0) {
                        targetValue = '0';
                    } else if (event.target.value && parseInt(event.target.value) > 100) {
                        targetValue = '100';
                    }
                }

                if (targetValue && targetValue.includes('.')) {
                    targetValue = event.target.value.replace('.', '');
                }

                if (
                    field === FieldNames.featureFields.durability &&
                    targetValue &&
                    targetValue.includes('-')
                ) {
                    targetValue = targetValue.replace('-', '');
                }
                setLocalValue(targetValue);
                debounceTextFn(event, targetValue, value);
            }}
            disabled={isDisabled}
            fullWidth={useFullWidth}
            variant={variant ? variant : 'standard'}
            placeholder={placeholder ? placeholder : ''}
            error={isError}
            helperText={helperText}
            {...inputProps}
            type={type}
            min={min}
            max={max}
        />
    );
}
